import { css, Theme } from '@emotion/react'
import { COURSE_COLORS, CourseName } from 'theme/utils'

export const chartTooltip = (isVisible: boolean, courseName: CourseName, displayToTheLeft: boolean) => (theme: Theme) =>
  css`
    position: absolute;
    z-index: 1;

    visibility: ${isVisible ? 'visible' : 'hidden'};

    padding: 8px 9px;
    border-radius: 12px;
    border: 1px solid ${theme.backgrounds.backgroundOne};

    transform: ${displayToTheLeft ? `translate(calc(-100% - 40px), -50%)` : `translateY(-50%)`};

    background-color: #f3f7fb;
  `

export const tooltipTriangle = (courseName: CourseName, displayToTheLeft: boolean) =>
  css`
    position: absolute;
    z-index: 0;

    top: 50%;

    color: #f3f7fb;

    ${displayToTheLeft
      ? css`
          right: -4px;
          transform: translateY(-50%) scaleX(-1);
        `
      : css`
          left: -4px;
          transform: translateY(-50%);
        `};
  `

export const blurredBackground = (courseName: CourseName) =>
  css`
    position: absolute;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;

    background: radial-gradient(
      circle at center,
      transparent 0%,
      transparent 90%,
      ${COURSE_COLORS[courseName].main} 95%
    );
    filter: blur(21.5px);
    overflow: hidden;

    :before {
      content: '';
      position: absolute;
      z-index: 1;

      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: ${COURSE_COLORS[courseName].main};
    }
  `

export const title = (theme: Theme) => css`
  color: ${theme.colors.backgroundOne};
  font-size: 14px;
  font-weight: 600;

  margin-bottom: 7px;
`

export const ul = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(0.5)};

  padding: 0;
  margin: 0;

  list-style-type: none;
`

export const li = css`
  display: flex;
  list-style-type: none;
  flex-wrap: nowrap;
  justify-content: space-between;

  width: 100%;

  font-size: 14px;
`

export const text = css`
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
`

export const key = (theme: Theme) =>
  css`
    padding-right: 12px;
    color: ${theme.colors.backgroundOne};
  `

export const value = (theme: Theme) =>
  css`
    color: ${theme.colors.backgroundOne};
  `

export const pastPracticeTest = (theme: Theme) => css`
  color: ${theme.colors.white};
`
